import { memo } from "react";
import {
  BlockStack,
  Text,
} from "@shopify/ui-extensions-react/customer-account";
import { useFileUploadInstructions } from "../hooks/useFileUploadInstructions";
import { FileUploadInstructionsProps } from "../types";

export const FileUploadInstructions = memo(({
  seatRequirements,
  maxFiles,
}: FileUploadInstructionsProps) => {
  const { instructionText, instructionSubtext } = useFileUploadInstructions({
    seatRequirements,
    maxFiles,
  });

  return (
    <BlockStack spacing="tight">
      <Text>{instructionText}</Text>
      <Text appearance="subdued">{instructionSubtext}</Text>
    </BlockStack>
  );
});
